import React, {useState, useEffect, Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {
    FlipToBack,
    FlipToFront,
    OpenWith
} from "@material-ui/icons";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import Button from "@material-ui/core/Button";
import HTTPClient from "../../HTTPClient";
import Typography from "@material-ui/core/Typography";
import {getMessage} from "../../util";

const isDevel = process.env.REACT_APP_API_URL.indexOf("devel") != -1;

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    paragraph: {
        margin: theme.spacing(2)
    }
}));

const getZoomSignature = async (meetingId) => {
    const result = await HTTPClient({
        method: "get",
        url:
            process.env.REACT_APP_API_URL +
            "/meetings/" + meetingId + "/zoom_signature"
    });
    return (result.data);
}

const getWidth = function () {
    if (window.innerWidth > window.innerHeight) {
        return (window.innerWidth * 0.6);
    }
    else {
        return (window.innerWidth * 0.95);
    }
}

const getHeight = function () {
    if (window.innerWidth > window.innerHeight) {
        return (window.innerHeight * 0.75);
    }
    else {
        return (window.innerHeight * 0.45);
    }
}

const ZoomMeeting = (props) => {

    const [errorAlert, setErrorAlert] = useState(false);
    const [diabledZoomIntegration, setDisabledZoomIntegration] = useState(false);
    const [opened, setOpened] = useState(false);

    const [zoomUrl, setZoomUrl] = useState(props.meeting.video_conf_url);

    const [meetingConfig, setMeetingConfig] = useState({
        meetingNumber: "",
        tk: "",
        lang: 'es-ES',
        username: "",
        signature: ""
    });

    const serialize = function(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const setFixedTrue = function () {
        props.onFixed(true);
    }

    const setFixedFalse = function () {
        props.onFixed(false);
    }

    const initVideocall = function () {
        (async () => {
            try {
                const result = await getZoomSignature(props.meeting.slug);
                if (result.user.video_conf_url) {
                    setZoomUrl(result.user.video_conf_url);
                    if (result.user.disabled_zoom_integration) {
                        setErrorAlert(true);
                        setOpened(false);
                        setDisabledZoomIntegration(true);
                    }
                    else {
                        const video_conf_url_array = result.user.video_conf_url.split("?tk=");
                        const auxArray = video_conf_url_array[0].split("/");
                        setMeetingConfig( (prevState) => {
                            return {
                                ...prevState,
                                tk: video_conf_url_array[1],
                                meetingNumber: auxArray[auxArray.length-1],
                                username: result.user.data.name,
                                signature: result.zoomData
                            }
                        })
                        setErrorAlert(false);
                        setOpened(true);
                        setDisabledZoomIntegration(false);
                    }
                }
                else {
                    setZoomUrl(props.meeting.video_conf_url);
                    setErrorAlert(true);
                    setOpened(false);
                    setDisabledZoomIntegration(false);
                }
            } catch (error) {
                setZoomUrl(props.meeting.video_conf_url);
                setErrorAlert(true);
                setOpened(false);
                setDisabledZoomIntegration(false);
            }
        })();
    }

    useEffect(() => {
        if (!opened) {
            initVideocall();
        }
    }, [ opened]);

    return (
        <div style={{textAlign: "center"}}>
            {
                errorAlert ? (
                    <Fragment>
                            {diabledZoomIntegration ? (
                                <Fragment>
                                    <Typography style={{'color': 'blue'}}>
                                        {getMessage(props.meeting.meeting_type,'videoconference_desintegration_message',props.messages)}
                                    </Typography>
                                    <Button variant="contained" href={zoomUrl} color="primary"  target="_blank" rel="noopener">
                                        {getMessage(props.meeting.meeting_type,'videoconference_button',props.messages)}
                                    </Button>
                                </Fragment>
                            ) : (
                                <Typography style={{'color': 'red'}}>
                                    {getMessage(props.meeting.meeting_type,'videoconference_message_error',props.messages)}
                                </Typography>
                            )}
                        </Fragment>
                    ) : (
                    opened ? (
                        <Draggable handle=".handle">
                            {props.changeableWindow ? (
                                <div id="zoom-main-div" className={(props.isFixed) ? "custom-youtube-player-fixed" : "custom-youtube-player"}>
                                    <ResizableBox width={(props.isFixed) ? getWidth() : 480}
                                                  height={( props.isFixed) ? getHeight() : 360}
                                                  minConstraints={[225, 150]}
                                                  maxConstraints={[2096, 1048]} resizeHandles={props.isFixed ? [] : ['se']}>
                                        <Fragment>
                                            { (isDevel) ? (
                                                <iframe id="videocall-iframe"
                                                        title="EVoting Zoom (DEVEL)"
                                                        src={"/meeting-devel.html?" + serialize(meetingConfig)}
                                                        style={{"border": 0, "width": "100%", "height": "100%"}}
                                                        allow="microphone; camera; fullscreen"
                                                        sandbox="allow-forms allow-scripts allow-same-origin">
                                                </iframe>
                                            ): (
                                                <iframe id="videocall-iframe"
                                                        title="EVoting Zoom"
                                                        src={"/meeting.html?" + serialize(meetingConfig)}
                                                        style={{"border": 0, "width": "100%", "height": "100%"}}
                                                        allow="microphone; camera; fullscreen"
                                                        sandbox="allow-forms allow-scripts allow-same-origin">
                                                </iframe>
                                            ) }

                                            {(props.isFixed) ? (
                                                <div className="minimize">
                                                    <FlipToFront onClick={setFixedFalse}/>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="handle">
                                                        <OpenWith/>
                                                    </div>
                                                    <div className="open">
                                                        <FlipToBack onClick={setFixedTrue}/>
                                                    </div>
                                                </div>
                                            )
                                            }
                                        </Fragment>
                                    </ResizableBox>
                                </div>
                            ) : (
                                <div id="zoom-main-div" className="custom-youtube-player-fixed">
                                    <ResizableBox width={getWidth()}
                                                  height={getHeight()}
                                                  minConstraints={[225, 150]}
                                                  maxConstraints={[2096, 1048]} resizeHandles={[]}>
                                        <Fragment>
                                            { (isDevel) ? (
                                                <iframe id="videocall-iframe"
                                                        title="EVoting Zoom (DEVEL)"
                                                        src={"/meeting-devel.html?" + serialize(meetingConfig)}
                                                        style={{"border": 0, "width": "100%", "height": "100%"}}
                                                        allow="microphone; camera; fullscreen"
                                                        sandbox="allow-forms allow-scripts allow-same-origin">
                                                </iframe>
                                            ): (
                                                <iframe id="videocall-iframe"
                                                        title="EVoting Zoom"
                                                        src={"/meeting.html?" + serialize(meetingConfig)}
                                                        style={{"border": 0, "width": "100%", "height": "100%"}}
                                                        allow="microphone; camera; fullscreen"
                                                        sandbox="allow-forms allow-scripts allow-same-origin">
                                                </iframe>
                                            ) }
                                        </Fragment>
                                    </ResizableBox>
                                </div>
                            )}
                        </Draggable>
                    ) : (
                        <div>
                            <Typography style={{'color': 'red'}}>
                                {getMessage(props.meeting.meeting_type,'videoconference_message_error',props.messages)}
                            </Typography>
                        </div>
                    )
                )
            }
        </div>

    );
}

export default ZoomMeeting;